import styled from '@emotion/styled';

import { UserAccountModel } from '../utils/types';

export interface MyFigureProps {
  userAccount: UserAccountModel;
}

export function MyFigure({ userAccount }: MyFigureProps) {
  return (
    <>
      <Text>{userAccount.body.height}cm</Text>
      <Text>{userAccount.body.weight}kg</Text>
      {userAccount.body.sizeText && <Text>{userAccount.body.sizeText}</Text>}
    </>
  );
}

const Text = styled.span`
  padding-right: 3px;
  &::after {
    content: ',';
  }
  &:last-of-type {
    padding-right: 0;
  }
  &:last-of-type::after {
    display: none;
  }
`;
